import axiosInstance from "../../axiosInstance";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const getStudentChallange = createAsyncThunk(
  "get/studentChallange",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/userChallengeList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error.response.data);
    }
  }
);
const studentChallange = createSlice({
  name: "studentChallange",
  initialState: {
    challange: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentChallange.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStudentChallange.fulfilled, (state, action) => {
      state.loading = false;
      state.challange = action.payload;
    });
    builder.addCase(getStudentChallange.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default studentChallange.reducer;
